import {
  collection,
  doc,
} from 'firebase/firestore'

import { db } from './firebase'

export type PortalAppEnv = {
  env: string
  /** Dạng `mt_live_...abcd`. Khoá đầy đủ chỉ trả về một lần lúc tạo app. */
  apiKeyMasked?: string
  apiKeyHash?: string
}

export type PortalApp = {
  id: string
  name: string
  bundleId?: string
  packageName?: string
  createdAt?: any
  updatedAt?: any
  envs?: PortalAppEnv[]
}

export function userAppsCol(uid: string) {
  return collection(db, `portalTenants/${uid}/apps`)
}

export function userAppRef(uid: string, appId: string) {
  return doc(db, `portalTenants/${uid}/apps/${appId}`)
}


